import React from 'react';
import './AdminNavBarstyle.css'; // For button styles, adjust if needed

function PaginationBar({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  showInfo = true,
  label = 'productos',
}) {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  return (
    <div className="pagination-container" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '10px',
      margin: '20px 0',
      flexWrap: 'wrap'
    }}>
      {showInfo && (
        <div className="pagination-info" style={{ marginRight: '20px' }}>
          {`Mostrando ${totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage + 1)} - ${Math.min(currentPage * itemsPerPage, totalItems)} de ${totalItems} ${label}`}
        </div>
      )}
      <div className="pagination-controls" style={{ display: 'flex', gap: '5px' }}>
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className="pagination-btn"
        >
          Primera
        </button>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="pagination-btn"
        >
          Anterior
        </button>
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map(page => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={page === currentPage ? 'pagination-btn active' : 'pagination-btn'}
            style={page === currentPage ? { background: '#e60026', color: 'white', fontWeight: 'bold' } : {}}
          >
            {page}
          </button>
        ))}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="pagination-btn"
        >
          Siguiente
        </button>
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="pagination-btn"
        >
          Última
        </button>
      </div>
    </div>
  );
}

export default PaginationBar;
